module.exports = __webpack_public_path__ + "img/logo_gen.852d09d0.svg";